// #region imports

// --- Angular
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, combineLatest } from 'rxjs';
import { switchMap, first } from 'rxjs/operators';

// --- HS Code
import { LanguagesBaseService, OidcService } from '../services';
import { Constants, LanguageModel } from 'src/app/models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class LanguageInterceptorService implements HttpInterceptor {
  static languagesService: any;
  constructor(
    private languagesService: LanguagesBaseService,
    private oidcService: OidcService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return combineLatest([
      this.languagesService.selectedLanguage$,
      this.oidcService.isMobileUser$,
    ]).pipe(
      first(),
      switchMap(([language, isMobileUser]: [LanguageModel, boolean]) => {
        if (req.method === "GET" && language) {
          // Mobile (webview) sessions always receive English content from the
          // server, matching the app-wide English forced client-side (#2909).
          const lang = isMobileUser
            ? Constants.DEFAULT_LOCALE
            : (language.cultureCode ? `${language.isoTwoLetterName}-${language.cultureCode}` : language.isoTwoLetterName);
          const langParams = `culture=${lang}&ui-culture=${lang}`;
          const query = req.urlWithParams.replace(req.url, '');
          const newQuery = query.length > 0 ? query + '&' + langParams : '?' + langParams;
          const params = new HttpParams({fromString: newQuery});
          req = req.clone({
            params: params
          });
        }

        return next.handle(req);
      })
    );
  }
}
